import CONSTANTS from '../constants';
import LoginService from './LoginService';

export default {
  getLoyalties,
  redeemLoyalty,
  getEarnedRewards,
};

async function getLoyalties(loc_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOYALTIES.DEFAULT(loc_id)}`;
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  if (token) {
    headers['x-access-token'] = token.token;
    url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOYALTIES.USER_DEFAULT(loc_id)}`;
  }

  let loyalties = await fetch(url, {
    method: 'GET',
    headers: headers
  });
  loyalties = await loyalties.json();
  if (loyalties) return loyalties;

  throw new Error('Could not fetch loyalties');
}

async function getEarnedRewards(loc_id) {
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  headers['x-access-token'] = token.token;
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOYALTIES.EARNED_REWARDS(loc_id)}`;

  let earnedrewards = await fetch(url, {
    method: 'GET',
    headers: headers
  });
  earnedrewards = await earnedrewards.json();
  if (earnedrewards) return earnedrewards;

  throw new Error('Could not fetch earnedrewards');
}

async function redeemLoyalty(code, loc_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PROMOTIONS.CHECK(code, loc_id)}`;
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  if (token) {
    headers['x-access-token'] = token.token;
    url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PROMOTIONS.USER_CHECK(code, loc_id)}`;
  }

  let promotions = await fetch(url, {
    method: 'GET',
    headers: headers
  });

  promotions = await promotions.json();
  if (promotions) return promotions;

  throw new Error('Could not save reviews');
}
